import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { H2 } from 'foundations-components/transitional/components/H2';
import { StartsAtMicroCopy } from '../../../../components/merch-card/price-display/PriceStyledComponents';
import { MerchCardLayoutUI } from '../../../components/MerchCardLayoutUI';
import { useIsUngatedForInbound25 } from '../../../hooks/useIsUngated';
import { PriceByProductApiName } from '../../PriceByProductApiName';
import { PurchaseMotionsByProductApiNameAndLocation } from '../../PurchaseMotionsByProductApiNameAndLocation';
import { IncludedSeatsDisplayContainer } from '../seats-display/IncludedSeatsDisplayContainer';
import { SubtextDisplayContainer } from '../subtext-display/SubtextDisplayContainer';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const HubMerchCard = ({
  apiName,
  HubDescription,
  ProductIcon,
  Title,
  Features,
  columnStart = 1
}) => {
  const isUngatedForInbound25 = useIsUngatedForInbound25();
  return /*#__PURE__*/_jsx(MerchCardLayoutUI, {
    "data-test-id": `hub-tier-merch-card-${apiName}`,
    "data-selenium-id": `hub-tier-merch-card-${apiName}`,
    columnStart: columnStart,
    Title: /*#__PURE__*/_jsxs(Flex, {
      alignItems: "start",
      children: [ProductIcon, /*#__PURE__*/_jsx(H2, {
        typography: "heading-400",
        children: Title
      })]
    }),
    Subheading: HubDescription,
    Pricing: /*#__PURE__*/_jsxs(_Fragment, {
      children: [StartsAtMicroCopy, /*#__PURE__*/_jsx(Text, {
        as: "div",
        typography: "heading-400",
        children: /*#__PURE__*/_jsx(PriceByProductApiName, {
          productApiName: apiName,
          showPerMonth: true
        })
      })]
    }),
    Seats: /*#__PURE__*/_jsx(IncludedSeatsDisplayContainer, {
      productApiName: apiName
    }),
    Subtext: /*#__PURE__*/_jsx(SubtextDisplayContainer, {
      productApiName: apiName
    }),
    CTAs: /*#__PURE__*/_jsx(PurchaseMotionsByProductApiNameAndLocation, {
      productApiName: apiName,
      location: "MERCH_CARD"
    }),
    Features: Features,
    isUngatedForInbound25: isUngatedForInbound25
  });
};